import { render } from "./yx-auto-complete.vue?vue&type=template&id=5c869652&scoped=true"
import script from "./yx-auto-complete.vue?vue&type=script&lang=js"
export * from "./yx-auto-complete.vue?vue&type=script&lang=js"

import "./yx-auto-complete.vue?vue&type=style&index=0&id=5c869652&lang=scss"
import "./yx-auto-complete.vue?vue&type=style&index=1&id=5c869652&lang=scss&scoped=true"

import exportComponent from "/builds/x3-web/pc/pc-yunxiao/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c869652"]])

export default __exports__